import { useLanguage } from '../../i18n/LanguageContext';
import LanguageSwitcher from '../LanguageSwitcher';

export default function AuthHeroImage() {
  const { t } = useLanguage();

  return (
    <div className="auth-split-hero">
      <LanguageSwitcher variant="inline" />
      <div className="auth-hero-image-wrapper">
        <img src="/hero-car-care.png" alt="Futuristic car care" className="auth-hero-img" />
        <div className="auth-hero-image-overlay">
          <div className="auth-hero-content">
            <h1>{t('auth.brand')}</h1>
            <p>{t('auth.hero.tagline')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
